import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import MainRouter from './maintenance'

Vue.use(Router)

export default new Router({
  routes: [
   ...MainRouter,
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js